import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';

import {metaToSuelosCore, SueloCore, SUELOS_CORE_META} from '../models/suelos';

@Injectable({
  providedIn: 'root'
})
export class SueloService {

  getSuelosCoreMeta(): Observable<SueloCore[]> {
    return of(metaToSuelosCore(SUELOS_CORE_META.features));
    // esto no se porque se comentario, la url se saca de ConfigService.get('sueloMetaUrl');
    // return this.http.post(
    //   this.urlMeta,
    //   {
    //     where: '1=1',
    //     outFields: ['CODIGO', 'SUELO_R6', 'FACTOR_K', 'T'],
    //     returnGeometry: false,
    //     returnDistinctValues: true,
    //     f: 'json'
    //   }
    // ).pipe(
    //   map((r: SueloCoreMeta) => metaToSuelosCore(r.features)),
    //   catchError(_ => of(metaToSuelosCore(SUELOS_CORE_META.features)))
    // );
  }
}
